/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Flexible Slider js
(function () {

	if (!window.Swiper) {
		console.warn('Swiper library not loaded');
		return;
	};

	const flexibleSliders = document.querySelectorAll('.js-flexible-slider');
	flexibleSliders.forEach((sliderElement, index) => {

		const wrapper = sliderElement.closest('.js-flexible-slider-wrapper');

		const slidesPerView = sliderElement.getAttribute('data-slides-per-view');
		const fadeEffect = sliderElement.getAttribute('data-fade-effect');
		const autoHeight = sliderElement.getAttribute('data-auto-height');
		const autoPlay = sliderElement.getAttribute('data-auto-play');
		const showArrows = sliderElement.getAttribute('data-show-arrows');
		const showPagination = sliderElement.getAttribute('data-show-pagination');

		sliderElement.classList.add('flexible-slider' + index);

		const autoPlaySetting = {
			delay: autoPlay,
		};

		const paginationSetting = {
			el: wrapper.querySelector('.swiper-pagination'),
			type: 'bullets',
			clickable: true
		};

		const navigationSetting = {
			nextEl: wrapper.querySelector('.next-slide-btn'),
			prevEl: wrapper.querySelector('.prev-slide-btn'),
		};

		const sliderInstance = new Swiper('.flexible-slider' + index, {
			effect: fadeEffect === "1" ? 'fade' : 'slide',
			fadeEffect: {
				crossFade: true
			},
			slidesPerView: 1,
			spaceBetween: 20,
			preloadImages: false,
			// lazy: {
			//   checkInView:true,
			//   loadPrevNext:true,
			//   enabled:true
			// },
			autoplay: autoPlay != "0" ? autoPlaySetting : false,
			speed: 400,
			autoHeight: autoHeight === "1" ? true : false,
			// Navigation arrows
			pagination: showPagination ? paginationSetting : false,
			navigation: showArrows ? navigationSetting : false,
			breakpoints: {
				768: {
					slidesPerView: slidesPerView,
					spaceBetween: 40,
				}
			}
		});
	});

})();

